import { post } from '../utils/api';

import { useMutation } from 'react-query';

async function createMinutesPreview(data) {
  const res = await post('/meeting-minutes/preview', data);
  return res?.data;
}

async function uploadMinutes({ form, meetingId, title }) {
  const res = await post('/meeting-minutes', form, {
    params: { meeting_id: meetingId, title },
  });
  return res?.data;
}

export function useMeetingMinutesActions() {
  const {
    mutate: _createMinutesPreview,
    mutateAsync: createMinutesPreviewAsync,
    isSuccess: isPreviewSuccess,
    isError: isPreviewError,
    isLoading: isPreviewLoading,
    data: previewData,
  } = useMutation((data) => createMinutesPreview(data));

  const {
    mutate: _uploadMinutes,
    mutateAsync: uploadMinutesAsync,
    isSuccess: isUploadSuccess,
    isError: isUploadError,
    isLoading: isUploadLoading,
    data: uploadData,
  } = useMutation(uploadMinutes);

  return {
    createMinutesPreview: _createMinutesPreview,
    createMinutesPreviewAsync,
    isPreviewSuccess,
    isPreviewError,
    isPreviewLoading,
    previewData,
    uploadMinutes: _uploadMinutes,
    uploadMinutesAsync,
    isUploadSuccess,
    isUploadError,
    isUploadLoading,
    uploadData,
  };
}
